import { CheckIcon, XMarkIcon } from "@storytell/bsky-icons";
import clsx from "clsx";
import { type Component, For, type ParentComponent, Show, createSignal } from "solid-js";
import { Portal } from "solid-js/web";
import { PricingPage } from "~/page/PricingPage";

interface PricingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PricingModal: Component<PricingModalProps> = (props) => {
  return (
    <Show when={props.isOpen}>
      <Portal>
        {/* Backdrop */}
        {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
        <div class="fixed inset-0 bg-black/20 backdrop-blur-sm z-[99999]" onClick={props.onClose}>
          {/* Modal Container */}
          <div class="fixed inset-0 overflow-y-auto bg-canvas/60">
            <PricingPage inModal />
          </div>
        </div>
      </Portal>
    </Show>
  );
};
